<script setup>
const props = defineProps({
  checked: {
    type: Boolean,
    required: true,
  },
});
</script>

<template>
  <label class="checkbox-v" :class="{ 'checkbox-v_checked': checked }">
    <input class="checkbox-v__input" type="checkbox" :checked="props.checked">
    <div class="checkbox-v__check" />
    <div class="checkbox-v__slot"><slot /></div>
  </label>
</template>

<style lang="scss">
@import 'node_modules/bootstrap/scss/mixins/_visually-hidden.scss';

.checkbox-v {
  &_checked {
    .checkbox-v__check {
      border-color: $primary;

      &::before,
      &::after {
        opacity: 1;
      }
    }
  }
}

.checkbox-v__check {
  position: relative;
  display: inline-block;
  width: 20px;
  min-width: 20px;
  height: 20px;
  border: 1px solid $primary;
  vertical-align: middle;

  &::before,
  &::after {
    content: '';
    position: absolute;
    background-color: $primary;
    border-radius: 3px;
    opacity: 0;
    transition: opacity 200ms ease-in;
  }

  &::before {
    top: 10.4px;
    left: 2.1px;
    width: 7px;
    height: 2px;
    transform: rotate(45deg);
  }

  &::after {
    top: 8.1px;
    left: 4.9px;
    width: 12px;
    height: 2px;
    transform: rotate(-50deg);
  }
}

.checkbox-v__input {
  @include visually-hidden;

  &:focus + .checkbox-v__check {
    outline: 1px solid $primary;
  }
}

.checkbox-v__slot {
  display: inline;
  vertical-align: middle;
  word-break: break-word;
}
</style>
